export default "__VITE_ASSET__BN4c1rnc__"